import React, { Component } from "react";
import { translate } from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../generics/WaitingModal';
import SearchBar from '../generics/SearchBar';
import swal from 'sweetalert';
import TableResults from './components/TableResults';
import $ from 'jquery';
import moment from 'moment';
import Help from '../generics/help';

window.$ = window.jQuery = require("jquery");
require('ms-signalr-client');
var Config = require('../../config');
var _hub;
var ChatProxy;
var ChatUrl = Config.default.apiGateway.short_url + "signalr";

var Config = require('../../config');

class ResultsDonation extends Component {
  constructor(props, context) {
    super(props);
    this.getItems = this.getItems.bind(this);

    var aux_date = new Date();
    //Definicion de variables
    this.state = {
      start_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
      end_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
      filterText:"",
      items:[],
      filter_type:"pending",
      filters:[{key:"all", value:"TODOS"}, {key:"pending",value:"PENDIENTES VALIDAR"}, {key:"reject",value:"RECHAZADOS"}, {key:"discrepant",value:"DISCREPANTES"}],
      register_types:[{key:"all", value:"TODOS"},{key:"bag_entries", value:"BOLSAS EXTERNAS"},{key:"donations", value:"DONACIONES"}]
    };
  }

  componentWillMount() {
    setTimeout(function(){
      this.getItems();
    }.bind(this), 100);

    //Actualizar listado por mensaje del servidor
    _hub = $.hubConnection(ChatUrl, {
      useDefaultPath: false
    });

    ChatProxy = _hub.createHubProxy('ChatHub');
    ChatProxy.getItems = this.getItems;

    ChatProxy.on("addNewMessageToPage", function(name, message) {
      console.log(window.location.hash);
      if(message === "refresh_validation_list" && window.location.hash === '#/results_donation'){
        this.getItems();
        console.log('llamando desde '+window.location.hash);
      }
    });

    _hub.start()
    .done(function() {
      console.log("Connected to Signalr Server");
    })
    .fail(function() {
      console.log("failed in connecting to the signalr server");
    });
  }

  handleChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  handleUserInput(filterText) {
    this.setState({filterText: filterText});
  };

  dateHandleChange = (event) => {
    this.setState({date:event.target.value});

    setTimeout(function(){
      this.getItems();
    }.bind(this), 100);
  }

  componentDidUpdate() {
  }

  dateCompare(){
    var ini = moment(this.state.start_date);
    var fin = moment(this.state.end_date);
    var date_ok = true;

    if(ini !== 'Invalid date' && fin !== 'Invalid date'){
      if(fin < ini){
        date_ok = false;
        document.getElementById('end_date').classList.add('error');
      }else{
        if(document.getElementById('end_date') !== null){
          document.getElementById('end_date').classList.remove('error');
        }
        
      }
    }else{
      date_ok = false;
    }   

    return date_ok;
  }
  
  getItems(){

    if(this.dateCompare()){
      if(this.waiting_modal !== null){
        this.waiting_modal.handleShow('Cargando...');
      }
      fetch(Config.default.apiGateway.URL+"donations?option=results_donation&health_facilities_id="+sessionStorage.getItem("health_facilities_id")+
        '&start_date='+this.state.start_date+'&end_date='+this.state.end_date+'&start_folio=&end_folio=&filter='+this.state.filter_type
        +"&convoke_places_id=all",{ 
          method: 'get',
          headers: new Headers({
             'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
             'Accept': 'application/json',
              'Content-Type': 'application/json',
          })
        })
        .then(res => {
          if(this.waiting_modal !== null){
            this.waiting_modal.handleClose();
          }
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(error) {
                swal('¡Error!', error, 'error');
              });
          }
        })
        .then(response => {
          if(response !== undefined){
            this.setState({ items: response });
          }
        })
      }else{
        swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
      }
      
  }

  //Contenido de la pantalla Listado
  render() {
    const { t } = this.props;

    return (
      <div className="col-xs-12">
        <div className="route">
          <h5 className="title_page" >
            {sessionStorage.getItem('health_facilities_name')} ->
            {t('sidebar.nav.laboratory.MAIN')} -> 
            {t('sidebar.nav.laboratory.results_donation')}
          </h5>
        </div>

        <Help 
            {...this.props}
            menu={"help_laboratory"} 
            submenu={"help_results_donation"}  /> 
        <div className="col-xs-12">
          <div className="col-xs-12 col-md-2">
            <span className="span-min">{t('content.validation_donation.start_date')+':'}</span>
            <input className="form-control" type="date" value={this.state.start_date} name="start_date" id="start_date" onChange={ this.handleChange}/>
          </div>
          <div className="col-xs-12 col-md-2">
            <span className="span-min">{t('content.validation_donation.end_date')+':'}</span>
            <input className="form-control" type="date" value={this.state.end_date} name="end_date" id="end_date" onChange={ this.handleChange}/>
          </div>
          <div className="col-xs-12 col-md-2">
            <span className="span-min">Tipo:</span> 
            <select className="form-control" onChange={ this.handleChange }
                value={ this.state.register_type || "" }  name="register_type" id="register_type" >
                  {
                  this.state.register_types.map(function(t) {
                    return <option key={t.key}  value={t.key} >{t.value} </option>;
                  })
              }
            </select>
          </div>
          <div className="col-xs-12 col-md-2">
            <span className="span-min">Estatus:</span> 
            <select className="form-control" onChange={ this.handleChange }
                value={ this.state.filter_type || "" } 
                  name="filter_type" id="filter_type" >
                  {
                  this.state.filters.map(function(t) {
                    return <option key={t.key}  value={t.key} >{t.value} </option>;
                  })
              }
            </select>
          </div>

          <div className="col-xs-12 col-sm-1" style={{paddingTop:"12px"}}>
            <button style={{float:"right", fontSize:"1em"}} className="btn btn-info" type="button" onClick={(e) => this.getItems()}>
              {t('content.generics.buttons.search')}
            </button>
          </div>
        </div>
        <div className="col-xs-12 form-group">
          <div className="col-xs-12 col-sm-2">
            <span className="span-min">Buscar:</span>
            <SearchBar filterText={this.state.filterText} onUserInput={this.handleUserInput.bind(this)}/>
          </div>
        </div>
        <div className="col-xs-12">
            <TableResults filterDate={this.state.date} filterText={this.state.filterText} {...this.props} onRef={ref => (this.table = ref)} 
              items={this.state.items} 
              refresh={this.getItems}
              search={this.props.search} 
              state={this.state}
              />
        </div>
        <Notifications />
        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
      </div>
    );
  }
}

export default translate('translations')(ResultsDonation)